import {AppConstants, AppDispatch} from 'redux/constants';
import {store} from 'redux/store';

const startApp: () => AppDispatch = () => ({
    type: AppConstants.startApp
});

export const initApp = () => store.dispatch(startApp());